module.exports = new __parcel__URL__("mining_mission_logo_image.5fbf3210.png").toString();